import Account from '@app/organisms/Settings/assets/Account.svg?react';
import DarkAccount from '@app/organisms/Settings/assets/DarkAccount.svg?react';
import { Table } from 'antd';
import React, { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Text } from '../../../../../styles/reactnative';
import { ThemeContext } from '../../../../../theme/ThemeProvider';
import moment from 'moment-timezone';
import { useFetcher } from '../../../../hooks/fetcher';
import { useTimezone } from '../../../../hooks/timezone';
import { getSetting, useSetting } from '../../../../hooks/user/mysetting';
import { SETTING_TYPE_SYSTEM } from '../../../../constants/SETTING';
import AccountInfoLists from '../AccountSecurityLists';
import { ProfileSecurities } from '../styles';
import CustomModal from '@/app/mobile/organisms/ProfileSetting/ProfileSettingBody/MAccountSecurity/CustomModal';
import useSWR from 'swr';
import { useToken } from '../../../../hooks';
import API from '../../../../../utils/api';
import NoData from '../../../../components/Common/CFlatList/NoData';
import styled from 'styled-components';

// 기본 스크롤바를 사용하는 래퍼 전역적으로 적용된 스크롤css를 사용하지 않고 여기서 적용
const DefaultScrollWrapper = styled.div<{ $scrollBg: string; $scrollThumb: string; $scrollThumbHover: string }>`
  ::-webkit-scrollbar {
    width: 12px !important;
    height: 12px !important;
    background: ${props => props.$scrollBg} !important;
  }

  ::-webkit-scrollbar-thumb {
    background: ${props => props.$scrollThumb} !important;
    border-radius: 0 !important;
    height: auto !important;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: ${props => props.$scrollThumbHover} !important;
  }

  ::-webkit-scrollbar-track {
    background: ${props => props.$scrollBg} !important;
  }

  ::-webkit-scrollbar-corner {
    background: ${props => props.$scrollBg} !important;
  }

  * {
    scrollbar-width: auto !important;
    scrollbar-color: ${props => props.$scrollThumb} ${props => props.$scrollBg} !important;
  }
`;

const AccountActivities = () => {
  const { t } = useTranslation();
  const { theme, isDarkMode } = useContext(ThemeContext);
  const { textw } = theme.COLORS;
  const [showModal, setShowModal] = useState(false);
  const [page, setPage] = useState(1);
  const [maxData, setMaxData] = useState(50);

  const { data: res } = useFetcher('/user/my/recenthistory', false);
  const { data: setting } = useSetting(SETTING_TYPE_SYSTEM);
  const userTimezone = getSetting(setting, 'TIMEZONE', 'Asia/Seoul');
  const { data: token } = useToken();

  const themeS = isDarkMode ? 'dark' : 'light';

  // 스크롤바 색상 설정
  const scrollColors = {
    bg: isDarkMode ? '#2a2a2a' : '#f1f1f1',
    thumb: isDarkMode ? '#666' : '#888',
    thumbHover: isDarkMode ? '#888' : '#555',
  };

  const last = res?.result?.result?.[0];

  // 모달용 테이블 데이터 조회
  const KEY = `/user/my/recenthistory?t=&maxData=${maxData}&page=${page}`;
  const { data: tableData } = useSWR<any>(
    showModal && token ? KEY : null,
    async () => {
      const response = await API.get(KEY, token + '', {});
      return response?.result?.result || response?.result;
    },
    { revalidateOnFocus: false, dedupingInterval: 0 }
  );

  const dataSource = tableData?.list || [];

  const data = [
    {
      image: themeS === 'light' ? DarkAccount : Account,
      title: t('accountActivities'),
      content:
        useTimezone(last?.created_at, 'YYYY-MM-DD HH:mm:ss', 0) +
        ' ' +
        t(last?.log),
      desc: t('accountAbnormalDeactivate'),
      button: {
        title: 'more',
        goTo: '',
        modelOpen: () => setShowModal(true),
      },
    },
  ];

  const columns = [
    {
      title: 'Date',
      dataIndex: 'created_at',
      align: 'center' as const,
      render: (text: string, record: any) => {
        const formattedTime = moment(record?.created_at)
          .utc()
          .tz(userTimezone)
          .format('YYYY-MM-DD HH:mm:ss');
        return (
          <Text style={{ color: textw, fontSize: 14, letterSpacing: -1 }}>
            {formattedTime}
          </Text>
        );
      },
    },
    {
      title: 'Log',
      dataIndex: 'log',
      align: 'center' as const,
      render: (text: string) => {
        return <Text style={{ color: textw }}>{t(text)}</Text>;
      },
    },
    {
      title: 'IP',
      dataIndex: 'ip',
      align: 'center' as const,
      render: (text: string) => {
        return (
          <Text style={{ color: textw }}>
            {text != 'undefined' ? text : ''}
          </Text>
        );
      },
    },
  ];

  return (
    <ProfileSecurities>
      <AccountInfoLists data={data} />
      <CustomModal
        open={showModal}
        centered={true}
        onCancel={() => setShowModal(false)}
        footer={false}
        title={t('log')}
        width={1200}
      >
        {dataSource?.length ? (
          <DefaultScrollWrapper
            $scrollBg={scrollColors.bg}
            $scrollThumb={scrollColors.thumb}
            $scrollThumbHover={scrollColors.thumbHover}
          >
            <Table
              pagination={{
                position: ['bottomCenter'],
                current: page,
                total: tableData?.totalCount || 1,
                pageSize: maxData,
                onShowSizeChange: (current, size) => {
                  setMaxData(size);
                  setPage(1);
                },
                onChange: (page) => setPage(page),
              }}
              dataSource={dataSource}
              columns={columns}
              scroll={{ x: 500, y: 650 }}
              size="small"
              style={{
                width: '100%',
                padding: 0,
                margin: 0,
              }}
            />
          </DefaultScrollWrapper>
        ) : (
          <NoData mt={'10%'} title={'NODATA'} />
        )}
      </CustomModal>
    </ProfileSecurities>
  );
};

export default AccountActivities;
